export enum ObjectType {
    document = 'document',
    user = 'user'
}